import { render, staticRenderFns } from "./JuridicoPrincipal.vue?vue&type=template&id=39ef0cdb&"
import script from "./JuridicoPrincipal.vue?vue&type=script&lang=js&"
export * from "./JuridicoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports